import React from 'react'
import PropTypes from 'prop-types'
import Loading from 'components/Loading'
import BeneficiaryList from './components/Beneficiary'
import FeatureGuard from '../../components/FeatureToggle/FeatureGuard'

const styles = Object.assign(
  {},
  require('./Beneficiaries.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
  { search: require('components/List/components/Search/Search.scss') },
)

class BeneficiariesView extends React.Component {
  static propTypes = {
    beneficiaries: PropTypes.object.isRequired,
    confirmBeneficiary: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
    deleteBeneficiary: PropTypes.func.isRequired,
    openBeneficiaryCommentForm: PropTypes.func.isRequired,
    openBeneficiaryForm: PropTypes.func.isRequired,
  }

  render() {
    const {
      beneficiaries, confirmBeneficiary, currentUser, deleteBeneficiary, openBeneficiaryCommentForm, openBeneficiaryForm,
    } = this.props
    if (beneficiaries.isFetching) { // || beneficiaries.isSaving) {
      return (<Loading pageLoading />)
    }
    return (
      <FeatureGuard featureName="Beneficiaries" user={currentUser}>
        <div className={styles.content}>
          <section className={styles.section}>
            <BeneficiaryList
              currentFy
              beneficiaries={beneficiaries}
              beneficiaryItems={beneficiaries.beneficiaries.filter(beneficiary => beneficiary.year === Number(beneficiaries.currentFy.current.year))}
              beneficiaryLocked={beneficiaries.isLocked}
              beneficiaryYear={beneficiaries.currentFy.current.year}
              confirmBeneficiary={confirmBeneficiary}
              currentUser={currentUser}
              deleteBeneficiary={deleteBeneficiary}
              openBeneficiaryCommentForm={openBeneficiaryCommentForm}
            // getBeneficiaries={this.props.getBeneficiaries}
            // beneficiary={this.props.beneficiaries.beneficiary}
              openBeneficiaryForm={openBeneficiaryForm}
            />
          </section>
          <section className={styles.section}>
            <BeneficiaryList
              subHeading
              beneficiaries={beneficiaries}
              beneficiaryItems={beneficiaries.beneficiaries.filter(beneficiary => beneficiary.year === Number(beneficiaries.currentFy.last.year))}
              beneficiaryLocked={beneficiaries.isLocked}
              beneficiaryYear={beneficiaries.currentFy.last.year}
              currentFy={false}
              currentUser={currentUser}
            />
          </section>
        </div>
      </FeatureGuard>
    )
  }
}

export default BeneficiariesView



// WEBPACK FOOTER //
// ./src/views/Beneficiaries/Beneficiaries.js